module.exports = __webpack_public_path__ + "3044a7b5348070d0d101cfe2cac4fb08.jpg";